import { ErrorBanner, SkeletonRows } from '@patchbay/ui'
import type { ErrorComponentProps } from '@tanstack/react-router'

/** Shown in the admin outlet. The root pending skeleton would replace the tab bar while a child loads (#626). */
export function AdminPending() {
  return <SkeletonRows count={6} />
}

/** Shown in the admin outlet. The root error page would unmount AdminLayout and its tab bar (#626). */
export function AdminError({ error, reset }: ErrorComponentProps) {
  return (
    <ErrorBanner title="This admin page failed to load" detail={error instanceof Error ? error.message : String(error)} onRetry={reset} />
  )
}

export const adminRouteState = {
  pendingComponent: AdminPending,
  errorComponent: AdminError,
}
